import { Requester } from './Requester';
import { IContactRecord, IManifest } from '../types';

export const PatchContact = async ({
    contactId,
    contact,
    surveyId
}: {
    contactId: string;
    contact: IManifest;
    surveyId?: string;
}): Promise<IContactRecord | null> => {
    try {
        const response = await Requester<IContactRecord | null>({
            path: `contacts/${contactId}`,
            method: 'PATCH',
            payload: contact,
            searchParams: surveyId ? `surveyId=${surveyId}` : undefined
        });

        return response && Object.hasOwn(response, '_id') ? (response as IContactRecord) : null;
    } catch (e) {
        console.error('Get contacts request failed');
        return Promise.reject(e);
    }
};
